if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        // ==== カートからの再編集時の上書き処理（古いものを事前に削除） ====
        const urlParams = new URLSearchParams(window.location.search);
        const editId = urlParams.get('edit_id');
        if (editId) {
          try {
            const cartRes = await fetch(`${window.routes?.cart_url || '/cart'}.js`);
            const cartData = await cartRes.json();
            const updates = {};
            cartData.items.forEach(item => {
               if(item.properties && item.properties['_bundle_id'] === editId) {
                  updates[item.key] = 0;
               }
            });
            if (Object.keys(updates).length > 0) {
               await fetch(`${window.routes?.cart_url || '/cart'}/update.js`, {
                 method: 'POST',
                 headers: { 'Content-Type': 'application/json' },
                 body: JSON.stringify({ updates })
               });
            }
          } catch(e) {
             console.error("Error deleting old bundle", e);
          }
        }
        // ==============================================================

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        // JSONで送信するため Content-Type の delete は削除

        let formData = new FormData(this.form);
        let items = [];
        
        let mainProductId = formData.get('id');
        let mainQuantity = parseInt(formData.get('quantity')) || 1;
        
        function generateUUID() {
          return 'xxxx-xxxx-4xxx-yxxx'.replace(/[xy]/g, function(c) {
            const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
          });
        }
        
        const addonInputs = document.querySelectorAll('.addon-quantity-input');
        let hasAddons = false;
        addonInputs.forEach(input => {
          if (parseInt(input.value) > 0) hasAddons = true;
        });
        
        let bundleId = hasAddons ? generateUUID() : null;
        let mainItemProperties = {};
        
        // Form内に隠された既存の property を抽出
        for(let [key, value] of formData.entries()) {
           if(key.startsWith('properties[')) {
             let propName = key.match(/properties\[(.*?)\]/)[1];
             mainItemProperties[propName] = value;
           }
        }
        // アドオンがある場合のみメイン商品に属性を付与する
        if (bundleId) {
          mainItemProperties['_bundle_id'] = bundleId;
          mainItemProperties['_edit_url'] = window.location.pathname + '?variant=' + mainProductId;
        }

        items.push({
          id: mainProductId,
          quantity: mainQuantity,
          properties: Object.keys(mainItemProperties).length > 0 ? mainItemProperties : undefined
        });

        // アドオン商品の追加
        addonInputs.forEach(input => {
          let qty = parseInt(input.value) || 0;
          if (qty > 0) {
            items.push({
              id: input.getAttribute('data-variant-id'),
              quantity: qty,
              properties: {
                '_bundle_id': bundleId,
                '_is_bundle_child': 'true',
                '_badge_text': input.getAttribute('data-badge-text') || '追加オプション'
              }
            });
          }
        });

        let payload = {
          items: items
        };

        if (this.cart) {
          payload.sections = this.cart.getSectionsToRender().map((section) => section.id).join(',');
          payload.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = JSON.stringify(payload);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            // 複数追加時({ items: [...] })は response 直下に key などのプロパティが不足するため補完
            if (response.items && response.items.length > 0 && !response.key) {
              response.key = response.items[0].key;
            }

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

// レンダリング直後にURLから再編集モードのパラメーターを検知して復元する
document.addEventListener('DOMContentLoaded', async () => {
  const urlParams = new URLSearchParams(window.location.search);
  const editId = urlParams.get('edit_id');
  if (!editId) return;

  try {
    const res = await fetch((window.routes?.cart_url || '/cart') + '.js');
    const cart = await res.json();
    
    let parentQty = 1;
    let addonQtys = {};

    cart.items.forEach(item => {
      if (item.properties && item.properties['_bundle_id'] === editId) {
          if (item.properties['_is_bundle_child'] === 'true') {
            addonQtys[item.variant_id] = item.quantity;
          } else {
            parentQty = item.quantity;
          }
      }
    });

    // メイン商品の数量復元
    const qtyInput = document.querySelector('product-info .quantity__input');
    if (qtyInput) {
      qtyInput.value = parentQty;
    }

    // アドオンの数量復元
    const addonInputs = document.querySelectorAll('.addon-quantity-input');
    addonInputs.forEach(input => {
        const vid = input.getAttribute('data-variant-id');
        if (addonQtys[vid]) {
          input.value = addonQtys[vid];
        }
    });

    // ボタンのラベルを「再編集としてカートを更新」にする（見た目の補助）
    const btnText = document.querySelector('product-info .product-form__submit span');
    if (btnText) {
      btnText.textContent = '内容を上書き保存する';
    }

  } catch (e) {
    console.error('Failed to restore edit data from cart:', e);
  }
});
